(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const controllerKey = '__dtailsFooterRevealController';

    if (window[controllerKey]?.destroy) {
      window[controllerKey].destroy();
    }

    const desktopQuery = window.matchMedia('(min-width: 768px)');
    const root = document.documentElement;
    const body = document.body;
    let observedSections = [];

    const getFooterSections = () =>
      Array.from(document.querySelectorAll('.shopify-section-group-footer-group'));

    const clearSectionOffsets = (sections) => {
      sections.forEach((section) => {
        section.style.removeProperty('--footer-reveal-bottom');
      });
    };

    const syncObservedSections = (sections) => {
      const hasChanged =
        sections.length !== observedSections.length ||
        sections.some((section, index) => section !== observedSections[index]);

      if (!hasChanged) return;

      resizeObserver.disconnect();
      observedSections = sections;

      observedSections.forEach((section) => {
        resizeObserver.observe(section);
      });
    };

    const update = () => {
      const footerSections = getFooterSections();
      syncObservedSections(footerSections);

      const revealFooter = footerSections
        .map((section) => section.querySelector('.footer--reveal-enabled'))
        .find(Boolean);
      const isEnabled = Boolean(revealFooter);
      const isActive = desktopQuery.matches && isEnabled;

      body.classList.toggle('footer-reveal-enabled', isEnabled);
      body.classList.toggle('footer-reveal-active', isActive);

      if (isEnabled) {
        const configuredRadius = Number(revealFooter?.dataset.footerRevealRadius);
        const revealRadius = Number.isFinite(configuredRadius)
          ? Math.max(0, configuredRadius)
          : 20;

        root.style.setProperty('--footer-reveal-radius', `${revealRadius}px`);
      } else {
        root.style.removeProperty('--footer-reveal-radius');
      }

      if (!isActive) {
        clearSectionOffsets(footerSections);
        root.style.removeProperty('--footer-reveal-height');
        return;
      }

      let combinedHeight = 0;

      for (let index = footerSections.length - 1; index >= 0; index -= 1) {
        const footerSection = footerSections[index];

        footerSection.style.setProperty(
          '--footer-reveal-bottom',
          `${combinedHeight}px`
        );

        combinedHeight += footerSection.getBoundingClientRect().height;
      }

      root.style.setProperty(
        '--footer-reveal-height',
        `${Math.ceil(combinedHeight)}px`
      );
    };

    const resizeObserver = new ResizeObserver(update);

    desktopQuery.addEventListener('change', update);
    window.addEventListener('resize', update);
    document.addEventListener('shopify:section:load', update);
    document.addEventListener('shopify:section:unload', update);

    requestAnimationFrame(update);

    window[controllerKey] = {
      destroy() {
        resizeObserver.disconnect();
        desktopQuery.removeEventListener('change', update);
        window.removeEventListener('resize', update);
        document.removeEventListener('shopify:section:load', update);
        document.removeEventListener('shopify:section:unload', update);
        clearSectionOffsets(getFooterSections());
        body.classList.remove('footer-reveal-enabled');
        body.classList.remove('footer-reveal-active');
        root.style.removeProperty('--footer-reveal-height');
        root.style.removeProperty('--footer-reveal-radius');
      },
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
